import styled from "styled-components";
import {device} from '../../../theme'
import { Container } from "../../../components/ui/wrapper";

export const SectionWrap = styled.section `
    padding-top: 100px;
    @media ${device.medium}{
        padding-top: 80px;
    }
    @media ${device.small}{
        padding-top: 60px;
    }
    .box-item{
        margin-top: 60px;
        @media ${device.small}{
            margin-top:47px;
        }
    }
`;

export const SectionBottom = styled.div `
    margin-top: 60px;
    text-align: center;
    @media ${device.small}{
        margin-top: 45px;
    }
`;

export const SectionTitle = styled.div `
    margin-bottom: 30px;
    text-align: center;
    @media ${device.small}{
        margin-top: 15px;
    }
`;

export const CareerOverviewMainContainer = styled(Container)`
    padding: 50px;
    margin-top: 50px;
`;